<template>
  <div>
    <div :class="{ require: item.require }" class="prompt">{{ item.title }}</div>
    <div
      class="upload-list"
      v-for="f in uploadList"
      :key="f.response"
      @click="handleView(f)"
    >
      <template v-if="f.status === 'finished'">
        <img :src="f.previewURL">
      </template>
      <template v-else>
        <Progress
          v-if="f.showProgress"
          :percent="f.percentage"
          hide-info
        />
      </template>
    </div>
    <!-- :accept="`.${uploadFormat.join(',.')}`" -->
    <Upload
      v-if="!readonly"
      ref="upload"
      class="upload"
      multiple
      type="drag"
      :show-upload-list="false"
      :format="uploadFormat"
      :accept="accept"
      :max-size="uploadMaxSize"
      :action="action"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
    >
      <div class="icon">
        <Icon type="ios-cloud-upload-outline" size="20"></Icon>
      </div>
    </Upload>
    <ImageView ref="imageView" title="查看图片" :list="uploadList" :deleteBtn="!readonly" @on-image-remove="handleRemove" />
  </div>
</template>

<script>
import ImageView from '@components/image-view'
export default {
  name: 'upload',
  components: { ImageView },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    prompt: {
      default: '',
      type: String
    },
    files: {
      default: () => [],
      type: Array
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      uploadList: [],
      tempFiles: []
    }
  },
  computed: {
    uploadFormat () {
      return this.$config.uploadFileFormat
    },
    uploadMaxSize () {
      return this.$config.uploadFileSize
    },
    accept () {
      return `.${this.$config.uploadFileFormat.join(',.')}`
    },
    action () {
      return `${this.$config.baseUrl}/api/Archives/UploadFiles`
    }
  },
  watch: {
    uploadList: {
      handler (val) {
        console.log(val);
        this.$emit('update:files', val)
      },
      deep: true
    },
    files: {
      handler (val) {
        console.log(val);
        this.uploadList = val
        if (this.$refs['upload']) {
          this.$refs['upload'].fileList = this.uploadList
        }
      },
      deep: true
    }
  },
  mounted () {
    !this.readonly && (this.uploadList = this.$refs['upload'].fileList)
  },
  methods: {
    handleView (file) {
      const index = this.uploadList.findIndex(f => f.response === file.response)
      this.$refs['imageView'].open(index)
    },
    handleRemove (index) {
      this.uploadList.splice(index, 1)
    },
    handleSuccess (res, file) {
      const original = this.tempFiles.find(f => f.name === file.name)
      const URL = window.URL || window.webkitURL
      file.previewURL = URL.createObjectURL(original)
      this.delTempFiles(file)
    },
    handleError (error, file) {
      this.$Message.warning(`${file.name}的文件上传失败`)
      this.delTempFiles(file)
    },
    handleFormatError (file) {
      this.$Message.warning(`${file.name}的文件格式不正确，请选择${this.uploadFormat.join('、')}`)
      this.delTempFiles(file)
    },
    handleMaxSize (file) {
      this.$Message.warning(`文件${file.name}过大，不要超过${this.uploadMaxSize / 1024}M`)
      this.delTempFiles(file)
    },
    handleBeforeUpload (file) {
      // 检查上传重复文件
      if (this.uploadList.some(s => s.name === file.name)) return false
      this.tempFiles.push(file)
    },
    delTempFiles (file) {
      const index = this.tempFiles.findIndex(f => f.name === file.name)
      this.tempFiles.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 4px;
  cursor: pointer;
  img {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.upload {
  @width: 58px;
  width: @width;
  display: inline-block;
  .icon {
    width: @width;
    height: @width;
    line-height: @width;
  }
}
.prompt {
  line-height: 20px;
  color: #515a6e;
  margin: 8px 0;
}
</style>
